export function hasMatchingBackgroundClass(element) {
  const regex = /^has-\w+-background-color$/;
  return Array.from(element.classList).find(cls => regex.test(cls));
}

export function removeMatchingBackgroundClasses(element) {
  const regex = /^has-\w+-background-color$/;
  const matchingClasses = Array.from(element.classList).filter(cls => regex.test(cls));
  if (matchingClasses) {
    matchingClasses.forEach(cls => element.classList.remove(cls));
  }
}

function waitForImagesToLoad(images) {
  const promises = Array.from(images).map(image => 
    new Promise((resolve, reject) => {
      if (image.complete && image.naturalWidth !== 0) {
        // Image is already loaded
        resolve(image);
      } else {
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error(`Failed to load image: ${image.src}`));
      }
    })
  );

  return Promise.all(promises);
}

export class batch {
    sts = [];
    constructor({ container }) {
        this.container = container;
        this.header = document.body.querySelector("header");
        this.main = document.body.querySelector("main");

        this.mount()
    }
    mount() {
        this.clean();
        const imgs = this.container.querySelectorAll("img");
        console.log(imgs);
        waitForImagesToLoad(imgs)
            .then(loadedImages => {
                console.log('All images loaded:', loadedImages);
                // Proceed with your logic here
                ScrollTrigger.refresh()
            })
            .catch(error => {
                console.error('Error loading images:', error);
            });
        const sections = this.container.querySelectorAll(".entry-content > *, footer.wp-block-template-part");
        sections.forEach((trigger, index) => {
            if ((index === 0 && trigger.classList.contains("wp-block-omnicom-portal"))) {
                const matchingClass = "has-contrast-background-color"
                this.main.classList.add(matchingClass);
                this.header.classList.add(matchingClass);
                return
            } else if (trigger.classList.contains("wp-block-omnicom-picture-full")) {
                return
            }
            this.sts.push(this.createScrollTriggerColor({ trigger }))
        })
        this.setBodyScroll()
    }
    clean() {
        removeMatchingBackgroundClasses(this.main);
        removeMatchingBackgroundClasses(this.header);
        const helper = document.body.querySelector(".header-helper")
        helper.classList.remove("untopped")
        if (helper.classList.contains("undocked")) {
            helper.classList.remove("undocked")
            gsap.to(helper, {
                yPercent: 0
            })
        }
    }
    setBodyScroll() {
        const st = ScrollTrigger.create({
            trigger: this.container.querySelector(".entry-content"),
            endTrigger: this.container.querySelector("footer"),
            scroller: this.container,
            start: 'top top',
            end: 'bottom bottom',
            onUpdate: (self) => {
                if (self.progress < 0.05) {
                    const helper = document.body.querySelector(".header-helper")
                    helper.classList.remove("untopped")
                } else {
                    const helper = document.body.querySelector(".header-helper")
                    helper.classList.add("untopped")
                }
                if (self.direction === 1 && self.progress > 0) {
                   const helper = document.body.querySelector(".header-helper")
                   if (!helper.classList.contains("undocked")) {
                        helper.classList.add("undocked")
                        gsap.to(helper, {
                            yPercent: -100
                        })
                    }
                } else {
                   const helper = document.body.querySelector(".header-helper")
                   if (helper.classList.contains("undocked")) {
                        helper.classList.remove("undocked")
                        gsap.to(helper, {
                            yPercent: 0
                        })
                    }
                    
                }
            },
            invalidateOnRefresh: true,
            // markers: true
        });
        this.sts.push(st)
    }
    createScrollTriggerColor({
        trigger
    }) {
        const st = ScrollTrigger.create({
            trigger,
            scroller: this.container,
            start: 'top center',
            end: 'bottom center',
            onToggle: (self) => {
                if (self.isActive) {
                    const matchingClass = trigger.classList.contains("has-background") && hasMatchingBackgroundClass(trigger);
                    if (matchingClass) {
                        removeMatchingBackgroundClasses(this.main);
                        this.main.classList.add(matchingClass);
                        this.header.classList.add(matchingClass);
                    } else {
                        this.clean();
                    }

                }
            },
            invalidateOnRefresh: true,
            // markers: true
        });
        return st;
    }
    dispose() {
        this.sts.forEach(_ => _.kill(false))
    }
}